import React, { Component } from 'react'
import { provideState, injectState } from 'freactal'
import app from '../../../../feathers'
import { getSection, getQuestion, sectionIndexToPath } from '../../../../lib'
import MappingDialog from '../../../components/MappingDialog'
import ScrollingDialog from '../../../../components/ScrollingDialog'
import Button from '../../../../components/Button'

const withState = provideState({
  initialState: () => ({
    updateQuestionMappingError: null,
  }),
  effects: {
    updateQuestionMapping: async (
      effects,
      { _id, sectionIndex, questionIndex, mapping },
    ) => {
      try {
        const sectionPath = sectionIndexToPath(sectionIndex)
        const questionPath = `sections.${sectionPath}.questions.${questionIndex}`
        await app.service('units').patch(_id, {
          [`${questionPath}.mapping`]: mapping,
        })
      } catch (updateQuestionMappingError) {
        return () => ({ updateQuestionMappingError })
      }
    },
  },
})

class QuestionMapping extends Component {
  state = {
    mapping:
      getQuestion(
        this.props.state.unit,
        this.props.match.params.sectionIndex.split('.'),
        this.props.match.params.questionIndex,
      ).mapping || [],
    saving: false,
  }
  pushToSection = () =>
    this.props.history.push(
      `/units/${this.props.state.unit
        ._id}/learner-guide/${this.props.match.params.sectionIndex.slice(
        0,
        3,
      )}/`,
    )
  handleChangeMapping = mapping => this.setState({ mapping })
  saveMapping = async () => {
    const {
      match: { params: { sectionIndex, questionIndex } },
      state: { unit },
      effects: { updateQuestionMapping },
    } = this.props
    const { mapping } = this.state
    this.setState({ saving: true })
    await updateQuestionMapping({
      _id: unit._id,
      sectionIndex,
      questionIndex,
      mapping,
    })
    this.setState({ saving: false })
    this.pushToSection()
  }
  render() {
    const {
      state: { unit },
      match: { params: { questionIndex, sectionIndex } },
    } = this.props
    const { saving, mapping } = this.state
    const hasQuestion = getQuestion(unit, sectionIndex, questionIndex)
    return hasQuestion ? (
      <MappingDialog
        title={`Mapping for Question ${parseInt(questionIndex, 10) + 1}`}
        goBack={this.pushToSection}
        mapping={mapping}
        mappingWhitelist={getSection(unit, sectionIndex.split('.')).mapping}
        onChangeMapping={this.handleChangeMapping}
        saveMapping={this.saveMapping}
        displaySpinner={saving}
      />
    ) : (
      <ScrollingDialog
        actions={
          <Button raised primary onClick={this.pushToSection}>
            Close
          </Button>
        }>
        <h3>Question Not Found</h3>
      </ScrollingDialog>
    )
  }
}

export default withState(injectState(QuestionMapping))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/QuestionMapping.js